export const MANUAL_COMMAND_ERROR_MESSAGE = 'Error, please try again.';
